export const studentCourseGroupsActionTypes =  {
    LOAD_STUDENT_COURSE_GROUPS_SUCCESS: 'LOAD_STUDENT_COURSE_GROUPS_SUCCESS',
    LOAD_STUDENT_COURSE_GROUPS_FAILURE: 'LOAD_STUDENT_COURSE_GROUPS_FAILURE',
}

export const studentGroupConceptsActionTypes =  {
    LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS: 'LOAD_STUDENT_GROUP_CONCEPTS_SUCCESS',
    LOAD_STUDENT_GROUP_CONCEPTS_FAILURE: 'LOAD_STUDENT_GROUP_CONCEPTS_FAILURE',
}